import { Flex } from '@chakra-ui/react';
import Select from 'react-select';
import { useField } from 'formik';
import { getCustomStyles } from '@/theme/components/select';
import { KText } from '@/ui-library/components/text';

const TimeField = ({
  label,
  fieldKey,
  options = [],
  newStyles = [],
  onChange = () => {},
}) => {
  const [field, meta, helpers] = useField(fieldKey);
  const { setValue, setTouched, setError } = helpers;
  const { value } = field;
  const { error, touched } = meta;

  const setFieldProps = ({ value }) => {
    setValue(value);
    onChange(value);
    setTouched(true);
    setError(null);
  };

  const isError = touched && error && !value;

  return (
    <Flex flexDir="column" w="100%" margin="0.75em 0">
      <KText size="sm-medium" color="secondary-900" mb="8px">
        {label}
        <KText as="span" color="#E53E3E" size="sm-regular">
          *
        </KText>
      </KText>
      <Select
        options={options}
        value={options?.find((option) => option.value === value) || ''}
        styles={getCustomStyles([
          ...newStyles,
          {
            type: 'control',
            boxShadow: isError ? '0 0 0 2px #A32020' : 'none',
          },
        ])}
        boxShadow={isError && '0 0 0 2px #A32020'}
        hasError={isError}
        components={{
          IndicatorSeparator: null,
        }}
        onChange={setFieldProps}
      />
      {isError && (
        <KText color="ats-negative" size="sm" mt="8px">
          {error}
        </KText>
      )}
    </Flex>
  );
};

export default TimeField;
